import "./ProductServices.css";
import "./ProductServicesResponsive.css";

import Banner from "../../../shared/banner/Banner";
import leaf from "../../../assets/images/products-serv/leafs.jpg";
import Tabs from "../../../widgets/tabs/Tabs";
import tabData from "../../../assets/data/product-services/productServices.json";
import ProductScroller from "../../../widgets/products-scroller/ProductScroller";
import CustomAnchor from "../../../shared/Anchor/CustomAnchor";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isMobile } from "react-device-detect";
import Accordion from "../../../widgets/accordion/Accordion";

function ProductServices() {
  // console.log(tabData);
  return (
    <>
      <Banner>
        <span>ABOUT US</span>
        <span>/</span>
        <span>PRODUCTS & SERVICES</span>
      </Banner>

      <div className="row m-0 mt-5 product-services-overview">
        <div className="col-md-6 col-sm-6 col-12">
          <img
            src={leaf}
            alt="Farm Overview"
            className="rounded"
            onContextMenu={(e) => e.preventDefault()}
          />
        </div>
        <div className="col-md-6 col-sm-6 col-12">
          <div className="about-us-content-wrapper">
            <div className="d-block">
              <h2>FRESH, FUNCTIONAL, AND FARM-FORWARD</h2>
              <div className="about-header-border"></div>
              <p>
                At <strong>Standout Fresh Produce</strong>, we go beyond just
                farming—we deliver freshness, convenience, and nutrition through
                every offering. From hand-picked vegetables and ready-to-cook
                options to innovative value-added products and wellness
                education, our goal is simple: to nourish people and the planet.
                Whether you're a health-conscious shopper, a busy food service
                provider, or an organization seeking impact-driven partnerships,
                you'll find smart, sustainable solutions tailored to your needs.
              </p>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className="product-service-title">
        <h1>
          <span className="product-service-title-products">
            OUR PRODUCTS & SERVICES
          </span>
        </h1>
      </div>
      <hr />
      <div className="standout-products-services-tabs">
        <Tabs data={tabData} />
      </div>
      <div className="standout-products-services-accordion">
        <Accordion data={tabData} />
      </div>
      <hr />
      <div className="row m-0 product-service-container">
        <div className="product-service-header">
          <h1>FRESHLY PRODUCED VEGES</h1>
          <CustomAnchor
            path="/shop"
            classname="btn btn-light product-service-shop-btn"
          >
            <span>SHOP NOW</span>
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
          </CustomAnchor>
        </div>
        <ProductScroller delay={2000} slides={isMobile ? 1 : 4} />
      </div>
    </>
  );
}

export default ProductServices;
